export const MAX_UPLOAD_SIZE_BYTES = 2_000_000_000; // 2 GB (SI)
